export const SITE = {
  // Nav
  navBrand: 'nav-brand',
  navLinkServices: 'nav-link-services',
  navLinkManifesto: 'nav-link-manifesto',
  navLinkProtocol: 'nav-link-protocol',
  navLinkPricing: 'nav-link-pricing',
  navLinkContact: 'nav-link-contact',
  navBookCta: 'nav-book-cta',
  navMobileToggle: 'nav-mobile-toggle',

  // Hero
  heroSection: 'hero-section',
  heroTitle: 'hero-title',
  heroSubtitle: 'hero-subtitle',
  heroSqueegee: 'hero-squeegee',
  heroScrollHint: 'hero-scroll-hint',
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',

  // Manifesto
  manifestoSection: 'manifesto-section',
  manifestoChapter: 'manifesto-chapter',

  // Services
  servicesSection: 'services-section',
  serviceResidential: 'service-residential',
  serviceCommercial: 'service-commercial',

  // Protocols
  protocolsSection: 'protocols-section',
  protocolItem: 'protocol-item',

  // Marquee
  marqueeSection: 'marquee-section',

  // Pricing
  pricingSection: 'pricing-section',
  pricingCard: 'pricing-card',

  // Testimonials
  testimonialsSection: 'testimonials-section',

  // Booking / Quote / Contact
  bookingSection: 'booking-section',
  tabContact: 'tab-contact',
  tabQuote: 'tab-quote',
  tabBooking: 'tab-booking',

  // Contact form
  contactForm: 'contact-form',
  contactName: 'contact-name',
  contactEmail: 'contact-email',
  contactPhone: 'contact-phone',
  contactMessage: 'contact-message',
  contactSubmit: 'contact-submit',

  // Quote form
  quoteForm: 'quote-form',
  quoteName: 'quote-name',
  quoteEmail: 'quote-email',
  quotePhone: 'quote-phone',
  quoteAddress: 'quote-address',
  quoteStories: 'quote-stories',
  quoteWindows: 'quote-windows',
  quoteFrequency: 'quote-frequency',
  quoteNotes: 'quote-notes',
  quotePropertyResidential: 'quote-property-residential',
  quotePropertyCommercial: 'quote-property-commercial',
  quoteServiceExterior: 'quote-service-exterior',
  quoteServiceInterior: 'quote-service-interior',
  quoteServiceScreen: 'quote-service-screen',
  quoteServiceTrack: 'quote-service-track',
  quoteSubmit: 'quote-submit',

  // Booking form
  bookingForm: 'booking-form',
  bookingName: 'booking-name',
  bookingEmail: 'booking-email',
  bookingPhone: 'booking-phone',
  bookingAddress: 'booking-address',
  bookingNotes: 'booking-notes',
  bookingPropertyResidential: 'booking-property-residential',
  bookingPropertyCommercial: 'booking-property-commercial',
  bookingServiceSelect: 'booking-service-select',
  bookingCalendar: 'booking-calendar',
  bookingTimeSlot: 'booking-time-slot',
  bookingSubmit: 'booking-submit',

  // Footer
  footer: 'site-footer',
  footerCta: 'footer-cta',
  footerPhone: 'footer-phone',
  footerEmail: 'footer-email',
};
